




























































import _ from 'lodash'
import moment from 'moment'
import { DataTablePagination } from '@/types/_'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import ModalProcedimentoCompartilhadoIncluir from './ModalProcedimentoCompartilhadoIncluir.vue'

@Component({
  components: {
    ModalProcedimentoCompartilhadoIncluir,
  },
})
export default class ProcedimentoCompartilhadoDataTable extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  loadProcedimentoCompartilhado: boolean = false
  get loadingProcedimentoCompartilhado() { return this.loadProcedimentoCompartilhado }
  set loadingProcedimentoCompartilhado(value: boolean) { this.loadProcedimentoCompartilhado = value }

  get procedimentosHeader() {
    return [
      { text: 'Incluído por', value: 'createdByNome', sortable: false, align: 'center' },
      { text: 'Incluído em', value: 'createdOn', sortable: false, align: 'center' },
      { text: 'Fonte pagadora', value: 'fontePagadoraNome', sortable: false, align: 'center' },
      { text: 'Valor de referência', value: 'valorReferencia', sortable: false, align: 'center' },
      { text: 'Tipo', value: 'tipo', sortable: false, align: 'center' },
      { text: 'Valor aplicar', value: 'valorAplicar', sortable: false, align: 'center' },
      { text: 'Função proc. origem', value: 'funcaoProcOrigem', sortable: false, align: 'center' },
      { text: 'Função proc. destino', value: 'funcaoProcDestino', sortable: false, align: 'center' },
      { text: 'Ações', value: '', sortable: false, align: 'center' },
    ]
  }

  get procedimentos() { return this.getRegrasDeCalculoStore.procedimentoCompartilhado }
  get paginacaoProcedimentos() { return this.getRegrasDeCalculoStore.paginacaoProcedimentos }
  procedimentosDebounce = _.debounce(param => this.getRegrasDeCalculoStore.getProcedimentoCompartilhadoAll(param), 700)

  async updatePaginationProcedimentos(pagination: DataTablePagination) {
    if (!this.getRegrasDeCalculoStore.modal.regraDeCalculo) return
    this.loadingProcedimentoCompartilhado = true
    this.procedimentosDebounce(pagination)
    this.loadingProcedimentoCompartilhado = false
  }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  loadDeletarProcedimentoCompartilhado: string = ''
  get loadingDeletarProcedimentoCompartilhado() { return this.loadDeletarProcedimentoCompartilhado }
  set loadingDeletarProcedimentoCompartilhado(value: string) { this.loadDeletarProcedimentoCompartilhado = value }

  get showModalProcedimentoCompartilhado() { return this.getRegrasDeCalculoStore.modal.procedimentoCompartilhado }
  set showModalProcedimentoCompartilhado(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'procedimentoCompartilhado', value }) }

  showModalincluirProcedimentoCompartilhado() {
    this.getRegrasDeCalculoStore.setModalProcedimentoCompartilhadoMode('CREATE')
    this.showModalProcedimentoCompartilhado = true
  }

  editProcedimentoCompartilhado(item: any) {
    this.getRegrasDeCalculoStore.setModalProcedimentoCompartilhadoMode('EDIT')
    this.getRegrasDeCalculoStore.setProcedimentoCompartilhadoId(item.id)
    this.getRegrasDeCalculoStore.setPercentualAplicar(item.valorAplicar)
    this.getRegrasDeCalculoStore.setTipoCompartilhamento(item.tipoCompartilhamento.key)
    this.getRegrasDeCalculoStore.setCodigoProcedimento(item.codigo)
    this.getRegrasDeCalculoStore.setGrupoRepasse(item.grupoRepasseId)
    this.getRegrasDeCalculoStore.setSubGrupoRepasse(item.subGrupoRepasseId)
    this.getRegrasDeCalculoStore.setFontePagadoraField(item.fontePagadoraId)
    if (item.funcaoOrigem) {
      this.getRegrasDeCalculoStore.setFuncaoProcOrigem(item.funcaoOrigem.key)
    }
    if (item.funcaoDestino) {
      this.getRegrasDeCalculoStore.setFuncaoProcDestino(item.funcaoDestino.key)
    }
    if (item.valorReferencia) {
      this.getRegrasDeCalculoStore.setValorReferencia(item.valorReferencia.key)
    }
    if (item.tipo) {
      this.getRegrasDeCalculoStore.setTipoField(item.tipo.key)
    }
    this.showModalProcedimentoCompartilhado = true
  }

  async removeProcedimentoCompartilhado(id: string) {
    this.loadingDeletarProcedimentoCompartilhado = id
    this.getRegrasDeCalculoStore.setProcedimentoCompartilhadoId(id)
    const request = await this.getRegrasDeCalculoStore.removeProcedimentoCompartilhado()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingDeletarProcedimentoCompartilhado = ''
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Procedimento excluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingDeletarProcedimentoCompartilhado = ''
  }
}
